<template>
  <div class="stage-update-popup">
    <van-popup v-model="isShowPopup" :close-on-click-overlay="false">
      <div class="popup">
        <div class="popup-container">
          <div class="congratulations">恭喜您，</div>
          <div class="stage-view">
            <div class="stage-container">
              <div class="stage-text">
                已完成{{ updatePopupInfo && updatePopupInfo.oldStageDisplayName }}阶段
              </div>
            </div>
          </div>
          <div class="target-view">
            <div class="target-title-container">
              <div class="line-left">
                <img class="line-left-img" src="../../../assets/images/home/Line_left@2x.png" alt=""/>
              </div>
              <div class="title">本阶段升级标准</div>
              <div class="line-right">
                <img class="line-right-img" src="../../../assets/images/home/Line_right@2x.png" alt=""/>
              </div>
            </div>
            <div class="target-detail-container">
              <div class="detail">
                <div class="detail-text" v-html="stageEvaluationCriteria"></div>
              </div>
            </div>
          </div>
          <div class="task-view">
            <div class="task-title-container">
              <div class="line-left-short">
                <img class="line-left-short-img" src="../../../assets/images/home/Line_left_short@2x.png" alt=""/>
              </div>
              <div class="title">在本阶段您累计完成了如下任务</div>
              <div class="line-right-short">
                <img class="line-right-short-img" src="../../../assets/images/home/Line_right_short@2x.png" alt=""/>
              </div>
            </div>
            <div class="task-detail-container">
              <div class="detail-list">
                <div class="detail-item" v-for="(item1, index1) in stageTasks" :key="index1">
                  <div class="item-title-container">
                    <div class="point"></div>
                    <div class="title">{{ item1 && item1.taskType }}</div>
                  </div>
                  <div class="sub-task-list">
                    <div class="sub-task-item" v-for="(item2, index2) in item1.list" :key="index2">
                      <div class="sub-task-item-container">
                        <div class="sub-task-item-name">
                          ·{{ item2 && item2.taskName }}：
                        </div>
                        <div class="sub-task-item-completed">
                          {{ item2 && item2.completedCount }}次
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="next-stage-btn-view" @click="closePopup">
            <div class="next-stage-btn-container">
              <div class="btn-tips">点击开启下一阶段</div>
              <div class="next-stage-name">
                {{ updatePopupInfo && updatePopupInfo.stageDisplayName }}
              </div>
            </div>
          </div>
        </div>
        <div class="arrow-bg"></div>
      </div>
      <div class="close-btn" @click="closePopup">
        <img class="close-btn-img" src="../../../assets/images/home/ic_fork@2x.png" alt=""/>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {getJourneyStageData, getStageTask, modifyPopupState} from '@/api/api'

export default {
  name: '',
  data() {
    return {
      isShowPopup: false,
      stageEvaluationCriteria: '',
      stageNo: '',
      stageName: '',
      stageTasks: [],
      newxStageData: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    updatePopupInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    isShow: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.isShowPopup = newValue
          this.standardClearance()
          this.stageTask()
        }
      },
      deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    // 获取旅程阶段信息 过关标准
    standardClearance() {
      if (this.updatePopupInfo.oldJourney) {
        let params = {
          journeyName: this.updatePopupInfo.oldJourney,
          name: this.updatePopupInfo.oldStage
        }
        getJourneyStageData(params).then(res => {
          console.log('sup standardClearance', res)
          if (res && res.data) {
            // 处理换行问题
            let eva = res.data.evaluationCriteria
            let pattern1 = /\(+[0-9]+\)/gi
            let pattern2 = /;|:/gi
            if (pattern1.test(eva)) {
              this.stageEvaluationCriteria = eva.replace(pattern1, rs => {
                return '<br>' + rs
              })
            } else if (pattern2.test(eva)) {
              this.stageEvaluationCriteria = eva.replace(pattern2, rs => {
                return rs + '<br>'
              })
            } else {
              this.stageEvaluationCriteria = eva
            }
          }
        })
      }
    },
    // 获取旅程阶段任务
    stageTask() {
      let params = {
        multiCode: this.userInfo.multiCode,
        journeyName: this.updatePopupInfo.oldJourney,
        stageName: this.updatePopupInfo.oldStage
        // multiCode: 'MULD100100170'
      }
      getStageTask(params).then(res => {
        console.log('sup stageTask', res)
        if (res && res.data) {
          // 处理tasks数据问题
          let stageTasks = JSON.parse(JSON.stringify(res.data))
          if (stageTasks.length > 0) {
            // 拿到所有任务类型的名称
            let stageTaskTypeList = stageTasks.map(item => {
              return item.taskType
            })
            const resultArr = Array.from(new Set(stageTaskTypeList))
            // 把相同的任务类型放进同一个数组内
            let arri = []
            for (let j = 0; j < resultArr.length; j++) {
              const element2 = resultArr[j]
              let arrj = stageTasks.filter(item1 => {
                return item1.taskType === element2
              })
              let obj = {}
              obj.taskType = element2
              obj.list = arrj
              arri.push(obj)
            }
            console.log('arri', arri)
            this.stageTasks = JSON.parse(JSON.stringify(arri))
          }
        }
      })
    },
    closePopup() {
      let params = {
        multiCode: this.userInfo.multiCode
      }
      modifyPopupState(params)
        .then(res => {
          console.log('unlockProject res', res)
        })
        .catch(err => {
          console.log('unlockProject err', err)
        })
      this.isShowPopup = false
      this.$emit('closePopup')
    }
  }
}
</script>

<style lang="less" scoped>
.stage-update-popup {
  position: relative;

  .popup {
    width: 275px;
    min-height: 510px;
    // background-image: url('../../../assets/images/home/bg_low@2x.png');
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    .popup-container {
      width: 275px;
      min-height: 427px;
      position: relative;
      margin-top: 83px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-image: url('../../../assets/images/home/bg_low2@2x.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      z-index: 10;

      .congratulations {
        margin-top: 24px;
        width: 225px;
        height: 29px;
        font-size: 21px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        color: #000000;
        line-height: 29px;
      }

      .stage-view {
        width: 225px;
        min-height: 22px;
        max-height: 66px;
        overflow: hidden;

        .stage-container {
          width: 225px;
          min-height: 22px;
          max-height: 66px;
          overflow: hidden;

          .stage-text {
            width: 225px;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            color: #000000;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }
      }

      .target-view {
        margin-top: 34px;
        width: 255px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .target-title-container {
          width: 255px;
          display: flex;
          align-items: center;

          .line-left {
            width: 74px;
            height: 8px;
            line-height: 8px;

            .line-left-img {
              width: 74px;
              height: 8px;
            }
          }

          .line-right {
            width: 74px;
            height: 8px;
            line-height: 8px;

            .line-right-img {
              width: 74px;
              height: 8px;
            }
          }

          .title {
            width: 98px;
            height: 20px;
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            color: #EB1700;
            line-height: 20px;
            margin: 0 2px;
          }
        }

        .target-detail-container {
          margin-top: 8px;
          width: 255px;

          .detail {
            width: 255px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .detail-text {
              width: 180px;
              font-size: 12px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
            }
          }
        }
      }

      .task-view {
        margin-top: 16px;
        padding-bottom: 78px;
        width: 255px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .task-title-container {
          width: 255px;
          display: flex;
          align-items: center;

          .line-left-short {
            width: 25px;
            height: 8px;
            line-height: 8px;

            .line-left-short-img {
              width: 25px;
              height: 8px;
            }
          }

          .line-right-short {
            width: 25px;
            height: 8px;
            line-height: 8px;

            .line-right-short-img {
              width: 25px;
              height: 8px;
            }
          }

          .title {
            width: 196px;
            height: 20px;
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            color: #EB1700;
            line-height: 20px;
            margin: 0 2px;
          }
        }

        .task-detail-container {
          width: 255px;

          .detail-list {
            width: 255px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .detail-item {
              width: 180px;
              display: flex;
              flex-direction: column;
              align-items: center;

              .item-title-container {
                margin-top: 8px;
                width: 180px;
                display: flex;
                align-items: center;

                .point {
                  width: 4px;
                  height: 4px;
                  background: #EB1700;
                  border-radius: 50%;
                  margin-right: 4px;
                }

                .title {
                  width: 135px;
                  height: 17px;
                  font-size: 12px;
                  font-family: Source Han Sans CN, Source Han Sans CN;
                  font-weight: 400;
                  color: #2b2b2b;
                  line-height: 17px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  flex: 1;
                }
              }

              .sub-task-list {
                width: 180px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .sub-task-item {
                  width: 180px;
                  margin-top: 8px;

                  .sub-task-item-container {
                    width: 180px;
                    display: flex;
                    align-items: center;

                    .sub-task-item-name {
                      max-width: 150px;
                      height: 17px;
                      font-size: 12px;
                      font-family: Source Han Sans CN, Source Han Sans CN;
                      font-weight: 400;
                      color: #858585;
                      line-height: 17px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }

                    .sub-task-item-completed {
                      height: 17px;
                      font-size: 12px;
                      font-family: Source Han Sans CN, Source Han Sans CN;
                      font-weight: 400;
                      color: #858585;
                      line-height: 17px;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .next-stage-btn-view {
        position: absolute;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
        width: 235px;
        height: 46px;
        background: linear-gradient(270deg, #ff5a0b 0%, #ffb063 100%);
        border-radius: 4px;

        .next-stage-btn-container {
          width: 235px;
          height: 46px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .btn-tips {
            font-size: 12px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            line-height: 17px;
          }

          .next-stage-name {
            width: 197px;
            font-size: 12px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            line-height: 17px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
          }
        }
      }
    }

    .arrow-bg {
      width: 133px;
      height: 120px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background-image: url('../../../assets/images/home/bg_low1@2x.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      z-index: 9;
    }
  }

  .close-btn {
    position: absolute;
    top: 39px;
    right: 0px;
    width: 28px;
    height: 28px;

    .close-btn-img {
      width: 28px;
      height: 28px;
    }
  }

  /deep/ .van-popup {
    background-color: transparent;
    overflow-y: visible;
    z-index: 10004 !important;
  }

  /deep/ .van-overlay {
    z-index: 10003 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/StageUpdatePopup.vue